import moment from 'moment'

const mutations = {
	/**
	 * [selectedBranch description]
	 * @param  {[type]} state     [description]
	 * @param  {[type]} branch_id [description]
	 * @return {[type]}           [description]
	 */
	selectedBranch(state, branch_id) {
		state.selectedBranch=branch_id
		localStorage.setItem('selected_branch', branch_id)
	},
	/**
	 * [setAccount description]
	 * @param {[type]} state   [description]
	 * @param {[type]} account [description]
	 */
	setAccount(state, account) {
		state.account=account
	},

	/**
	 * [user description]
	 * @param  {[type]} state   [description]
	 * @param  {[type]} payload [description]
	 * @return {[type]}         [description]
	 */
	user(state, payload){
		state.user={...payload}
		localStorage.setItem('user', JSON.stringify(state.user))
	},

	/**
	 * [access_token description]
	 * @param  {[type]} state   [description]
	 * @param  {[type]} payload [description]
	 * @return {[type]}         [description]
	 */
	access_token(state, payload) {
		state.access_token=payload.access_token
		state.refresh_token=payload.refresh_token
		state.refreshDate=new Date()
		localStorage.setItem('access_token', state.access_token)
		localStorage.setItem('refresh_token', state.refresh_token)
	},

	/**
	 * [clear description]
	 * @param  {[type]} state [description]
	 * @return {[type]}       [description]
	 */
	clear(state) {
		localStorage.removeItem('access_token')
		localStorage.removeItem('refresh_token')
		localStorage.removeItem('user')
		state.user=false
		state.access_token=''
		state.refresh_token=''
	}
}

const getters = {
	/**
	 * [selectedBranch description]
	 * @param  {[type]} state [description]
	 * @return {[type]}       [description]
	 */
	selectedBranch(state) {
		return state.selectedBranch || localStorage.getItem('selected_branch') || null
	},
	/**
	 * [coop description]
	 * @param  {[type]} state   [description]
	 * @param  {[type]} getters [description]
	 * @return {[type]}         [description]
	 */
	coop(state, getters) {
		if(getters.selectedBranch&&getters.coops.length) {
			return getters.coops.find(item => item.id == getters.selectedBranch)
		}

		return null
	},
	/**
	 * [coop description]
	 * @param  {[type]} state   [description]
	 * @param  {[type]} getters [description]
	 * @return {[type]}         [description]
	 */
	coops(state, getters) {
		return ((getters.user||{}).coops||[]).map(item => item.coop)
	},
	/**
	 * [roles description]
	 * @param  {[type]} state [description]
	 * @return {[type]}       [description]
	 */
	roles(state, getters) {
		return (getters.user||{}).roles||[]
	},

	/**
	 * [permissions description]
	 * @param  {[type]} state [description]
	 * @return {[type]}       [description]
	 */
	permissions(state, getters) {
		return (getters.user||{}).permissions||[]
	},

	/**
	 * [account description]
	 * @param  {[type]} state   [description]
	 * @param  {[type]} getters [description]
	 * @return {[type]}         [description]
	 */
	account(state, getters) {
		return state.account
	},

	/**
	 * [isLogin description]
	 * @param  {[type]}  state   [description]
	 * @param  {[type]}  getters [description]
	 * @return {Boolean}         [description]
	 */
	isLogin(state, getters) {
		return !!getters.user
	},

	/**
	 * [user description]
	 * @param  {[type]} state [description]
	 * @return {[type]}       [description]
	 */
	user(state) {
		if(!state.user) {
			return JSON.parse(localStorage.getItem('user'))	
		}
		return state.user
		// return !state.user?JSON.parse(localStorage.getItem('user')):state.user
	},

	/**
	 * [access_token description]
	 * @param  {[type]} state [description]
	 * @return {[type]}       [description]
	 */
	access_token(state) {
		if(!state.access_token) {
			return localStorage.getItem('access_token')	
		}

		return state.access_token
		// return !localStorage.getItem('access_token')?state.access_token:localStorage.getItem('access_token')
	},

	/**
	 * [refresh_token description]
	 * @param  {[type]} state [description]
	 * @return {[type]}       [description]
	 */
	refresh_token(state) {
		if(!state.refresh_token) {
			return localStorage.getItem('refresh_token')
		}

		return state.refresh_token
		// return !localStorage.getItem('refresh_token')?state.refresh_token:localStorage.getItem('refresh_token')
	}
}

export default {
	namespaced: true,
	state: {
		selectedBranch: null,
		user: false,
		access_token: '',
		refresh_token: '',
		refreshDate: null,
		account: null
	},

	mutations,
	getters,
	actions: {
		/**
		 * [session description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @return {[type]}                 [description]
		 */
		session({commit, getters}) {
			return this._vm.$http.get('session')
				.then(response => response.data)
		},

		/**
		 * [login description]
		 * @param  {[type]} options.commit   [description]
		 * @param  {[type]} options.getters  [description]
		 * @param  {[type]} options.username [description]
		 * @param  {[type]} options.password [description]
		 * @return {[type]}                  [description]
		 */
		login({commit, getters}, {username, password}) {
			return this._vm.$http.post('login', {
				email: username,
				password: password
			}).then(response => {
				commit('user', response.data.user)
				commit('access_token', response.data)
				return response.data
			})
		},

		/**
		 * [set_branch description]
		 * @param {[type]} options.commit  [description]
		 * @param {[type]} options.getters [description]
		 * @param {[type]} branch_id       [description]
		 */
		set_branch({commit, getters}, branch_id) {
			return this._vm.$http.put('branch', {}, {
				params: {id: branch_id}
			}).then(response => {
				commit('selectedBranch', response.data.coop)
				commit('access_token', {
					access_token: getters['access_token'],
					refresh_token: response.data.token
				})
				return response.data
			})

		},

		/**
		 * [logout description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @return {[type]}                 [description]
		 */
		logout({commit, getters}) {
			return this._vm.$http.get('logout')
				.then(response => {
					commit('clear')
					return response.data
				})
		},

		/**
		 * [refresh_token description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @return {[type]}                 [description]
		 */
		refresh_token({commit, getters}) {
			return this._vm.$http.post('refresh', {token: getters['refresh_token']})
				.then(response => {
					commit('user', response.data.user)
					commit('access_token', response.data)
					return response.data
				})
		}
	},

}